import { render } from "./VReCaptcha.vue?vue&type=template&id=5b82d9e7&scoped=true"
import script from "./VReCaptcha.vue?vue&type=script&lang=js"
export * from "./VReCaptcha.vue?vue&type=script&lang=js"

import "./VReCaptcha.vue?vue&type=style&index=0&id=5b82d9e7&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b82d9e7"]])

export default __exports__